import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { NavController, PopoverController, ModalController } from '@ionic/angular';
import { AccountPaymentFavoriteService } from '@wlp/ui-bs-account-payment-favorite';
import { AccountPaymentRechargeBilletResponse, BilletLotService, BilletService, ChargingService } from '@wlp/ui-bs-cashin';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import * as moment from 'moment';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { ModalTokenComponent } from 'src/app/views/themes/sentinel/modals/modal-token/modal-token.component';
import { ModalAlertComponent } from 'src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component';


import { FavoritesDataFilterPipe } from '../../favorites-data-filter.pipe';
import { ModalBilletAlertCancelComponent } from 'src/app/views/themes/sentinel/modals/modal-billet-alert-cancel/modal-billet-alert-cancel';

@Component({
  selector: 'ui-t-billet-emit-confirmation',
  templateUrl: './billet-emit-confirmation.page.html',
  styleUrls: ['./billet-emit-confirmation.page.scss'],
  providers: [FavoritesDataFilterPipe],
})
export class CharginBilletEmitConfirmation implements OnInit {

  public errorMessages: any;
  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  private readonly OPERATION: string = '1002';
  public toggleSpinnerUpdate: boolean = false
  public AccountPaymentRechargeBillet: AccountPaymentRechargeBilletResponse

  soma = 0;
  page = 0;
  perPage = 10;

  dataBillets = {}

  dataLotBillets: any[] = []; 
  dataListaBoleto: any[] = [];
  qtdBoletos: any[] = [];
  
  drawerData: any;
  uuidLot: string;
  uuidAccontPaymet: string;
  billetData = []
  dataLot = {}

  emailData = {}

  documentPayer = {}
  namePayer = ""

  dataLotListBillets = [];

  constructor(
    public service: ChargingService,
    public serviceBillet: BilletService, 
    protected userInfoService: UserInfoService,
    private loadingService: LoadingService,
    private billetService: BilletService,
    public billetLotService: BilletLotService,
    private navCtrl: NavController,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
    public router: Router,
    public popoverController: PopoverController,
    public pipeFilter: FavoritesDataFilterPipe,
    private route: ActivatedRoute,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
    private modalController: ModalController,
    private cdr: ChangeDetectorRef
  ) {
    //console.log('## CharginBilletEmitConfirmation.constructor')
    moment.locale('pt-br');
  }

  ngOnInit(): void {
    //console.log('## CharginBilletEmitConfirmation.ngOnInit');
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    this.route.queryParams.subscribe(params => {
      this.uuidAccontPaymet = params["uuidAccontPaymet"]
      this.uuidLot =  params["uuidLot"]
      this.emailData = params["email"]
    })

    this.getLotListBillets(this.uuidAccontPaymet, this.uuidLot)

  }

  goBack() {
    this.navCtrl.navigateRoot('/app/charging/billet/v2/emit-detailed');
  }

  getLotBillets(uuidLot: string) {
    //console.log('## CharginBilletEmitConfirmation.getLotBillets uuidLot: ', uuidLot)
    this.loadingService.hide();
    this.billetService.getLot(uuidLot)
     .subscribe(
        (res2) => {     
          //console.log('getLot res: ', res2)
          this.toggleSpinnerUpdate = false
          this.dataLotBillets = res2;
        },
        (err) => {
          console.error('getLot err: ', err)
          this.loadingService.hide();
        },
        () => {
          this.loadingService.hide();
        }
    );
    this.cdr.detectChanges();
  }

  getLotListBillets(uuidAccount: string, uuidLot: string) { 
    this.loadingService.show();
    this.billetService.getLotListBillets(uuidAccount, uuidLot)
     .subscribe(
       (res3) => {
          this.toggleSpinnerUpdate = false

          this.billetData = res3.billets 
          this.dataLot = res3.lot
          this.documentPayer = this.billetData[0].documentPayer
          this.namePayer = this.billetData[0].namePayer

          this.getLotBillets(uuidLot);
        },
        (err) => {
          console.error(err);
          this.loadingService.hide();
        },
        () => {
          this.loadingService.hide();
        }
    );
    this.cdr.detectChanges();
  } 
  

  loadMore(event) {
    //console.log('## CharginBilletEmitConfirmation.loadMore')
    //console.log('event: ', event);
  }

  confirm() {
    this.validateToken();
  }

  public async validateToken(_confirmation?: boolean) {
    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
      },
      backdropDismiss: false,
    });

    modalToken.onDidDismiss().then((data) => {
      if (data['data'] && data['role']) {
        this.emitLot(data.role)
      }
    });

    return await modalToken.present();
  }

  async emitLot(token: string) {
    const body = {
      uuidLotBillet: this.uuidLot,
      uuidAccountPayment: this.uuidAccontPaymet,
      token,
    }
    this.loadingService.show();
    this.billetLotService.emitLot(body)
      .subscribe(
        response => {
          this.loadingService.hide();
          this.goToLotDetail();
        },
        error => {
          console.error('# emitLot error: ', error);
          this.statusNotification('warning-circle', 'CASH_IN.ACCOUNT_RECHARGE.MESSAGES.FAILED', true);
        })
  }

  goToLotDetail() {
    this.navCtrl.navigateRoot([`app/charging/billet/v2/lot/${this.uuidAccontPaymet}/${this.uuidLot}`]);
  }

  async cancelEmit() {
    const modalToken = await this.modalController.create({
      component: ModalBilletAlertCancelComponent,
      cssClass: 'modal-billet-alert-cancel',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true,
        confirm: () => this.goToLotDetail(),
        description: 'CASH_IN.ACCOUNT_RECHARGE.CONFIRMATION.MODAL.CANCEL.TITLE',
        alert2: 'CASH_IN.ACCOUNT_RECHARGE.CONFIRMATION.MODAL.CANCEL.TEXT',
        confirmBtn: 'CASH_IN.ACCOUNT_RECHARGE.CONFIRMATION.MODAL.CANCEL.BUTTON_CONFIRM',
        cancelBtn: 'CASH_IN.ACCOUNT_RECHARGE.CONFIRMATION.MODAL.CANCEL.BUTTON_CANCEL'
      },
      backdropDismiss: false,
    });
      
    return await modalToken.present();
  }

  private async statusNotification(status: string, message: string, translateFlag: boolean) {
    this.loadingService.hide();
    const translate = translateFlag ? true : false;
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message,
        confirmBtn: 'CASH_OUT.ACCOUNT_CHARGING.CLOSE_BUTTON',
        translate: translate,
        hasActionAfterConfirmation: true,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }
}
